import { useContext } from 'react';

import { PartnerRouterContext } from 'contexts/PartnerRouter/PartnerRouterContext';

export const usePartnerRouterContext = () => useContext(PartnerRouterContext);
